/* ===================================
 *  PcbRule Compiler related types
 * ===================================
 */
/**
 * The source type of rules flattened to a node.
 *
 * NOTE: objectSpecific and runtime types are not needed in this categorization
 * so far.
 */
export var PcbRuleSetType;
(function (PcbRuleSetType) {
    /**
     * Rules that were inherited from an ancestor node. Inheritability is a
     * property of the rule config. See allChildNodesWillInheritThisRule.
     */
    PcbRuleSetType["inherited"] = "inherited";
    /**
     * Global rulesets that were targeted by selector, AKA global rules.
     */
    PcbRuleSetType["selectorBased"] = "selectorBased";
    /**
     * Global rules that were not created in the document, but come from a
     * sub-document, AKA sublayout, AKA submodule. They should only apply to the
     * sub-document.
     */
    PcbRuleSetType["foreignGlobal"] = "foreignGlobal";
    /**
     * Global rules that are defined by the system and applied by default.
     */
    PcbRuleSetType["systemDefaultGlobal"] = "systemDefaultGlobal";
    /**
     * "Special" global rules that are defined by the system and applied by default,
     * but need to be applied with greater specificity than the
     * `systemDefaultGlobal` rules.
     */
    PcbRuleSetType["systemDefaultGlobalSpecial"] = "systemDefaultGlobalSpecial";
    /**
     * If the rule is coming from the parent net (keepouts)
     */
    PcbRuleSetType["netInherited"] = "netInherited";
})(PcbRuleSetType || (PcbRuleSetType = {}));
export const PcbRuleSetDefaultSpecificityMap = {
    [PcbRuleSetType.systemDefaultGlobal]: -3,
    [PcbRuleSetType.systemDefaultGlobalSpecial]: -2,
    [PcbRuleSetType.netInherited]: -1,
    [PcbRuleSetType.inherited]: 0,
    // 👇 specificity values for these ruleset types are computed using their selector value
    [PcbRuleSetType.selectorBased]: undefined,
    [PcbRuleSetType.foreignGlobal]: undefined,
};
export var FileSuffix;
(function (FileSuffix) {
    FileSuffix["modFile"] = ".mod";
    FileSuffix["kicadModFile"] = ".kicad_mod";
    FileSuffix["fluxFootprintFile"] = ".flx_ftp";
})(FileSuffix || (FileSuffix = {}));
//# sourceMappingURL=models.js.map